module.exports = __webpack_public_path__ + "static/img/yeswecan0038.ad5a48c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0038.png
// module id = 613
// module chunks = 1